import { IInitMessage } from '../modules/dashboard/components/DashboardContent/Pureweb/interfaces';
import { IGamecastStreamSession } from '../modules/dashboard/components/DashboardContent/GameCast/interfaces';
import axios from 'axios';
import {
  IGamecastConfig,
  IGamecastStreamGroup,
  IGetStreamGroupParams,
} from '../interfaces/gamecast';
import { env } from '../env';
interface StreamSessionData {
  gameName: string;
  description: string;
  participantId: string;
  websocketSessionId: string;
  signalRequest: string;
  timeout: number;
  streamId: string;
  initMessage: IInitMessage;
  region: string;
  launchArgs: string[] | null;
  sessionKey?: string;
}

interface StreamGroupIdResponse {
  eventId: string;
  streamGroupId: string;
  region: string;
}

export default class GameCastService {
  static startGameSession({
    gameName,
    description,
    participantId,
    websocketSessionId,
    signalRequest,
    timeout,
    streamId,
    initMessage,
    region,
    launchArgs,
    sessionKey
  }: StreamSessionData): Promise<IGamecastStreamSession> {
    return axios
      .post(
        `${env.REACT_APP_SPATIAL_MANAGER_API_URL}api/v2/gamecast/stream-session/new`,
        {
          gameName,
          description,
          participantId: participantId
            ? participantId.replace('ActiveDirectory_', '').replaceAll('_', '')
            : '',
          websocketSessionId,
          signalRequest,
          timeout,
          streamGroupId: streamId,
          initMessage,
          region,
          additionalLaunchArgs: [
            '-PixelStreamingDecoupleFramerate=true',
            '-PixelStreamingCaptureUseFence=true',
            '-ResX=1280',
            '-ResY=800',
            ...(launchArgs || []),
          ],
          sessionKey
        },
        {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        },
      )
      .then((res) => res.data);
  }

  static getGameSessionId(eventId: string): Promise<StreamGroupIdResponse> {
    return axios
      .get(`${env.REACT_APP_SPATIAL_MANAGER_API_URL}api/v2/gamecast/${eventId}`)
      .then((res) => res.data);
  }

  static async getStreamGroup(
    eventId: string,
    config = {},
  ): Promise<IGamecastStreamGroup> {
    return await axios
      .get(
        `${env.REACT_APP_SPATIAL_MANAGER_API_URL}api/v2/gamecast/${eventId}`,
        {
          ...config,
        },
      )
      .then((res) => res.data);
  }

  static async getStreamGroupConfig(
    { eventId, region, streamGroupId }: IGetStreamGroupParams,
    config = {},
  ): Promise<IGamecastConfig> {
    return await axios
      .get(
        `${env.REACT_APP_SPATIAL_MANAGER_API_URL}api/v2/gamecast/${eventId}/config`,
        {
          ...config,
          params: {
            region,
            streamGroupId,
          },
        },
      )
      .then((res) => res.data);
  }
}
